import FlowPolicyCollection from '../FlowPolicyCollection';
import EventPolicyModel from './EventPolicyModel';

class EventPolicyCollection extends FlowPolicyCollection {
  get url() {
    return '/api/ui/alerting/policies/kevent';
  }

  get model() {
    return EventPolicyModel;
  }
}

export default EventPolicyCollection;
